// extracted by mini-css-extract-plugin
module.exports = {"tableListItem":"TableListItem__tableListItem","link":"TableListItem__link","title":"TableListItem__title","icon":"TableListItem__icon","content":"TableListItem__content"};